import { render, staticRenderFns } from "./SpcmCounselorCalendar.vue?vue&type=template&id=63be8a48&scoped=true"
import script from "./SpcmCounselorCalendar.vue?vue&type=script&lang=js"
export * from "./SpcmCounselorCalendar.vue?vue&type=script&lang=js"
import style0 from "./SpcmCounselorCalendar.vue?vue&type=style&index=0&id=63be8a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be8a48",
  null
  
)

export default component.exports